import { LitElement, html } from './-global.min.js'

class HHLoadMore extends LitElement {
  static properties = {
    url: {
      type: String,
    },
    position: {
      type: String,
    },
    'target-class': {
      type: String,
    },
  }

  constructor() {
    super()
    this.position = 'next'
  }

  connectedCallback() {
    super.connectedCallback()
    this.addEventListener('submit', this.handleLoadMore.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  async handleLoadMore(e) {
    e.preventDefault()
    try {
      const url = this['url']
      const targetClass = this['target-class']

      this.setButtonLoading()

      if (this.position === 'next') {
        this.setPageUrl(url)
      }

      const res = await fetch(url)
      const data = await res.text()
      const dataDom = await new DOMParser().parseFromString(data, 'text/html')

      const newData = dataDom.querySelector(targetClass)
      document
        .querySelector(targetClass)
        .insertAdjacentHTML(
          this.position === 'previous' ? 'afterbegin' : 'beforeend',
          newData.innerHTML
        )

      document
        .querySelectorAll('[data-featured-link]')
        .forEach((nonAnchorLink) => {
          nonAnchorLink.addEventListener('click', () => {
            const link = nonAnchorLink.getAttribute('data-featured-link')
            window.location.href = link
          })
        })
      this.rerenderComponent(dataDom)
      setTimeout(() => {
        const firstNewProductCard = newData.querySelector(
          '.product-grid__item:first-of-type .js-anchor'
        )
        const firstNewProductCardLink = firstNewProductCard.getAttribute('href')
        const firstNewProductCardFocus = document.querySelector(
          `.js-product-grid-list .product-grid__item .js-anchor[href="${firstNewProductCardLink}"]`
        )
        firstNewProductCardFocus?.focus({ focusVisible: false })
      }, 0)
    } catch (error) {
      console.error(error)
    }
  }

  setButtonLoading() {
    const buttonEl = this.querySelector('.js-load-more, button[type="submit]')

    buttonEl.classList.add('is-loading')
    buttonEl.setAttribute('disabled', true)
  }

  rerenderComponent(data) {
    if (!data) return
    const elId = `#${this.getAttribute('id')}`

    const newLoadMore = data.querySelector(elId)?.outerHTML || ''
    this.outerHTML = newLoadMore
  }

  setPageUrl(url) {
    window.history.pushState({}, '', url)
  }

  render() {
    return html` <slot></slot> `
  }
}

customElements.define('hh-load-more', HHLoadMore)
